module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    attrs: {
      "id": "border"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Ce projet est soutenu par le Fonds Européen de Développement Régional et le Territoire Grand-Orly Seine Bièvre ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "foot"
    }
  }, [_c('p', {
    attrs: {
      "id": "offset"
    }
  }, [_vm._v("La formation Savoir Être Aidant est portée et développée par les associations :")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "legal"
    }
  }, [_c('router-link', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#app'),
      expression: "'#app'"
    }],
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Accueil")]), _vm._v(" — "), _c('router-link', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#app'),
      expression: "'#app'"
    }],
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("À propos")]), _vm._v(" — "), _c('router-link', {
    attrs: {
      "to": "/partners"
    }
  }, [_vm._v("Partenaires")]), _c('br'), _vm._v("\n            © 2017 — "), _c('router-link', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#app'),
      expression: "'#app'"
    }],
    attrs: {
      "to": "/legal"
    }
  }, [_vm._v("Mentions légales")]), _vm._v(" — "), _c('router-link', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#app'),
      expression: "'#app'"
    }],
    attrs: {
      "to": "/credits"
    }
  }, [_vm._v("Crédits")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "partners"
    }
  }, [_c('div', {
    staticClass: "partner"
  }, [_c('a', {
    attrs: {
      "href": "https://europa.eu/european-union/index_fr",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/Logo_UE_bleu CE-web.jpg",
      "alt": "Union Européenne"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "partner"
  }, [_c('a', {
    attrs: {
      "href": "http://www.europeidf.fr/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/IleDeFranceFEDERDeroule-web.png",
      "alt": "FEDER"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "partner"
  }, [_c('a', {
    attrs: {
      "href": "https://www.iledefrance.fr/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/IDF-Logo-quadri-couleur-web2.jpg",
      "alt": "Ile de France"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "partner"
  }, [_c('a', {
    attrs: {
      "href": "http://www.grandorlyseinebievre.fr/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/Logo-EPT12-bleu-web.jpg",
      "alt": "EPT12"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "porteur"
    }
  }, [_c('div', {
    staticClass: "partner"
  }, [_c('a', {
    attrs: {
      "href": "http://www.futurage.fr/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/futurage-logo-complet-web.png",
      "alt": "Futurage"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "partner"
  }, [_c('a', {
    attrs: {
      "href": "https://campusurbain.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo Campus urbain-web.jpg",
      "alt": "Campus Urbain"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a12dcf3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 446
// module chunks = 1